import { useEffect } from 'react';

const useBodyScroll = (enabled) => {
  useEffect(() => {
    if (process.browser) {
      document.body.style.overflow = enabled ? null : 'hidden';
      return () => {
        document.body.style.overflow = null;
      };
    }

    return () => {};
  }, [enabled]);
};

export default useBodyScroll;
